<script setup>
import { inject } from 'vue';
import Saisie from '@/components/generiques/Saisie.vue';
import ZoneSelectionFichier from '@/components/generiques/ZoneSelectionFichier.vue';

const { idErreur } = defineProps({
    idErreur: String
});

const valeur = defineModel('valeur', {
    type: Object
});

const erreursSaisie = inject('erreursSaisie');

function modifierValeur(fichier) {
    valeur.value = fichier;
}

</script>

<template>
    <Saisie :message-erreur="erreursSaisie[idErreur]">
        <ZoneSelectionFichier 
            v-model:fichier="valeur" 
            @update:fichier="modifierValeur"/>
    </Saisie>
</template>

<style scoped>

</style>